























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Drawer from '@/apps/ice/components/Drawer.vue'
import { getSms } from '@/api/account/sms'
import { changeMobile } from '@/api/account/user.ts'
import { State, Mutation, namespace } from 'vuex-class'

const accountUser = namespace('app-ice/account')

@Component({
  components: {
    Drawer
  }
})
export default class MobileDrawer extends Vue {
  @accountUser.Mutation('changeMobile')
  changeMobile!: (payload: string) => void

  @Prop()
  private visible!: boolean

  private mobile: string = ''
  private code: string = ''
  private isMobileError: boolean = false
  private isCodeError: boolean = false
  private localVisible: boolean = this.visible
  // 验证码倒计时
  private seconds: number = 60

  @Watch('visible')
  onVisibleChange() {
    if (this.visible) {
      this.localVisible = true
    }
  }

  @Watch('localVisible')
  onChange() {
    this.$emit('update:visible', this.localVisible)
    // 关闭抽屉时清空输入框
    if (!this.localVisible) {
      this.mobile = ''
      this.code = ''
      this.seconds = 60
    }
    if (this.localVisible && this.$refs.mobileInput) {
      ;(this.$refs.mobileInput as HTMLElement).focus()
    }
  }

  /**
   * 提交修改
   */
  private async confirm() {
    if (!this.checkValidate()) {
      return
    }

    const isSuccess = await changeMobile({
      mobile: this.mobile,
      smsCode: this.code
    })

    this.localVisible = false
    this.message(isSuccess)
    isSuccess && this.changeMobile(this.mobile)
  }

  /**
   * 提示修改结果
   */
  private message(isSuccess: boolean) {
    this.$ykdmessage({
      message: `修改手机号${isSuccess ? '成功' : '失败'}！`,
      duration: 1500,
      type: `${isSuccess ? 'success' : 'error'}`,
      cancel: () => {}
    })
  }

  /**
   * 获取验证码
   */
  private getCode() {
    if (!this.checkMobile()) {
      return
    }

    this.countDown()
    ;(this.$refs.codeInput as HTMLElement).focus()
    getSms(this.mobile)
  }

  /**
   * 倒计时
   */
  private countDown() {
    let timerId: any
    timerId = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--
      } else {
        clearInterval(timerId)
      }
    }, 1000)
  }

  get countDownTxt() {
    return this.seconds < 60 && this.seconds > 0
      ? `${this.seconds}S后重新获取`
      : '获取验证码'
  }

  /**
   * 验证手机号和验证码格式是否正确
   */
  private checkValidate() {
    return this.checkMobile() && this.checkCode()
  }

  private checkMobile() {
    this.isMobileError = !/1[23456789]\d{9}/.test(this.mobile)
    return !this.isMobileError
  }

  private checkCode() {
    this.isCodeError = this.code.length !== 6
    return !this.isCodeError
  }
}
